import { Button, Icon, Text } from '@chakra-ui/react'
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from '@apex/component-library'
import React from 'react'
import { FaInfoCircle } from 'react-icons/fa'

interface InfoPopoverProps {
  title?: string
  description: string
}

const InfoPopover = ({ title, description }: InfoPopoverProps) => (
  <Popover
    modifiers={[
      {
        name: 'offset',
        options: {
          offset: [-5, 10],
        },
      },
    ]}
    placement="top-start"
    trigger="click"
  >
    <PopoverTrigger>
      <Button
        variant="link"
        d="inline-block"
        h="1rem"
        minW="1rem"
        lineHeight={0}
        border={0}
        rounded="full"
      >
        <Icon as={FaInfoCircle} color="black" />
      </Button>
    </PopoverTrigger>
    <PopoverContent fontFamily="Inter, Helvetica, Arial, sans-serif">
      <PopoverArrow />
      {title && (
        <PopoverHeader>
          <Text fontSize="md" fontWeight="bold">
            {title}
          </Text>
        </PopoverHeader>
      )}
      <PopoverBody>
        <Text fontSize="md" fontWeight="regular">
          {description}
        </Text>
      </PopoverBody>
    </PopoverContent>
  </Popover>
)

export default InfoPopover
